<template>
  <div id="schedule-list">
    <BottomBar />
    <!-- <User v-if="components.user" @close="components.user = false" />
    <keep-alive>
      <Top :welcome="false" @user="components.user = true" />
    </keep-alive> -->
    <Empty
      v-if="!list || !list.length"
      :loading="list === undefined"
      :icon="true"
      title="暂无课表"
      subtitle="您还没有加入任何课表"
      link="/courses"
      link-text="去看看课程"
    />
    <main v-else>
      <div class="semicircle" />
      <div class="title">
        <h1>我的课表</h1>
      </div>
      <div class="links">
        <router-link tag="div" class="link" to="/homework">
          <i class="anyteachicon anyteach-pen" />
          <span>
            课后作业
          </span>
        </router-link>
        <div class="line" />
        <router-link tag="div" class="link" to="/exams">
          <i class="anyteachicon anyteach-hundred" />
          <span>
            考试报告
          </span>
        </router-link>
      </div>
      <div class="items">
        <Item v-for="item in list" :key="item.id" :data="item">{{ item }}</Item>
      </div>
    </main>
    <!-- <div class="cover">
      <img src="https://anyteach3.oss-cn-shenzhen.aliyuncs.com/assets/schedule-bgd.png" />
    </div> -->
  </div>
</template>

<script>
import Item from "./Item"
// // import Top from "@/components/public/top"
// // import User from "@/components/my/User"

export default {
  name: "ScheduleList",
  components: {
    Item,
    // Top,
    // User
  },
  data() {
    return {
      list: undefined,
      components: {
        user: false
      }
    }
  },
  created() {
    this.getList()
  },
  methods: {
    async getList() {
      this.list = await this.$api.schedule.LIST()
    }
  }
}
</script>

<style lang="scss" scoped>
$green: #47b181;
#schedule-list {
  padding-bottom: $bottom-bar;
  padding-bottom: $iphone-x-bottom-bar;
}
main {
  padding: 20px 5% 15px 5%;
  z-index: 1;
  position: relative;
  overflow-x: hidden;
}

.semicircle {
  // background: $blue;
  background: $green;
  width: 180%;
  height: 300px;
  border-radius: 100%;
  position: absolute;
  z-index: -1;
  top: -160px;
  left: 50%;
  transform: translate(-50%, 0%);
}
.cover {
  position: absolute;
  bottom: 60px;
  right: 10px;
  z-index: 0;
  img {
    height: 200px;
  }
}

.links {
  padding: 10px 0;
  margin: 15px auto 0 auto;
  box-shadow: $deep-shadow;
  transition: all 0.1s;
  border: $border;
  background: white;
  border-radius: 4px;
  display: flex;
  justify-content: space-around;
  align-items: center;
  .link {
    width: 100%;
    text-align: center;
    i {
      font-size: 25px;
      margin: 0 0 5px 0;
      color: $blue;
      color: $green;
      display: block;
    }
    span {
      // font-weight: bold;
      font-size: 0.8rem;
    }
  }
  .line {
    background: rgba(0, 0, 0, 0.1);
    width: 0.5px;
    height: 30px;
    position: absolute;
    // display: none;
  }
}
.title {
  z-index: 1;
  padding: 15px 0 0 0;
  h1 {
    font-size: 1.5rem;
    color: white;
    text-align: center;
  }
}
</style>